import { useState } from 'react';
import { marqueeItems, hotTargets } from '@/mocks/heiLiao';

export default function Hero() {
  const [tick, setTick] = useState(0);
  const [open, setOpen] = useState(false);
  const ticker = marqueeItems[tick];

  return (
    <section className="relative overflow-hidden border-b border-background-200/70">
      {/* 顶部分类条 + 存档切换 */}
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-3 px-4 pb-4 pt-5 md:px-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-[12px] font-medium text-foreground-600">
            <i className="ri-apps-2-line text-[14px] text-accent-600"></i>
            <span>全网快讯分类</span>
          </div>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 text-[12px] text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700"
          >
            <i className="ri-calendar-2-line text-[13px]"></i> 今日时间线
            <i className={`text-[12px] ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
          </button>
        </div>

        {/* 主区块：多卡并列 */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          {/* 卡1 - 主角 */}
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-4">
            <div className="mb-2.5 flex items-center justify-between">
              <h3 className="flex items-center gap-1.5 text-[13px] font-bold text-foreground-950">
                <i className="ri-emotion-line text-[14px] text-primary-500"></i> 今日曝光主角
              </h3>
              <a href="#expose-index" className="flex items-center gap-0.5 text-[11px] text-primary-600 hover:text-primary-700">
                全部 <i className="ri-arrow-right-line text-[11px]"></i>
              </a>
            </div>
            <div className="space-y-2">
              {hotTargets.slice(0, 3).map((t) => (
                <a href="#expose-index" key={t.rank} className="flex cursor-pointer items-center gap-2.5 rounded-lg bg-background-100/50 p-2 transition-colors hover:bg-primary-50">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded text-[11px] font-bold text-background-50 bg-primary-500">
                    {t.rank}
                  </span>
                  <span className="truncate text-[12px] font-medium text-foreground-800">{t.name}</span>
                  <span className="ml-auto shrink-0 text-[11px] font-bold text-accent-600">{t.heat}</span>
                </a>
              ))}
            </div>
          </div>

          {/* 卡2 - 档案搜索 */}
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-4">
            <div className="mb-2.5 flex items-center gap-1.5">
              <h3 className="flex items-center gap-1.5 text-[13px] font-bold text-foreground-950">
                <i className="ri-folder-open-line text-[14px] text-accent-600"></i> 主角档案入口
              </h3>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100/50 px-3 py-2">
              <p className="text-[11px] text-foreground-500">输入名字或关键词，直达新鲜黑料合集</p>
              <div className="mt-2 flex gap-2">
                <input className="min-w-0 flex-1 rounded-md border border-background-300/70 bg-background-50 px-2.5 py-1.5 text-[12px] outline-none placeholder:text-foreground-400 focus:border-accent-300" placeholder="搜：某顶流 / 直播" />
                <button className="flex shrink-0 items-center justify-center whitespace-nowrap rounded-md bg-secondary-900 px-2.5 text-[12px] text-background-50 hover:bg-secondary-700">
                  查档案
                </button>
              </div>
            </div>
            <div className="mt-2.5 flex flex-wrap gap-1.5">
              {['选秀', '直播', '演员', '爱豆', '商务'].map((k) => (
                <a key={k} href="#archive" className="rounded-full bg-background-200/60 px-2 py-0.5 text-[11px] text-foreground-600 hover:bg-accent-100 hover:text-accent-800">
                  {k}
                </a>
              ))}
            </div>
          </div>

          {/* 卡3 - 检索维度 */}
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-4 md:col-span-2 xl:col-span-1">
            <div className="mb-2.5 flex items-center gap-1.5">
              <h3 className="flex items-center gap-1.5 text-[13px] font-bold text-foreground-950">
                <i className="ri-archive-drawer-line text-[14px] text-secondary-700"></i> 追踪维度速览
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {[
                ['刚流出', '现场实拍 / 截图', 'ri-flashlight-fill', 'text-primary-500'],
                ['今日新料', '单据 / 行程 / 账目', 'ri-file-list-3-fill', 'text-accent-600'],
                ['考古回潮', '旧档 / 直播切片', 'ri-time-fill', 'text-secondary-700'],
                ['热议焦点', '舆论 / 口径对照', 'ri-chat-3-fill', 'text-primary-400'],
              ].map(([t, d, ic, cl]) => (
                <div key={t as string} className="rounded-lg bg-background-100/50 p-2.5">
                  <div className="flex items-center gap-1.5 text-[12px] font-semibold text-foreground-800">
                    <i className={`${ic as string} ${cl as string} text-[13px]`}></i>
                    {t as string}
                  </div>
                  <p className="mt-1 text-[10px] leading-snug text-foreground-500">{d as string}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 折叠的时间线速览 */}
        {open && (
          <div className="animate-rise mt-1 grid grid-cols-2 gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-4 md:grid-cols-4">
            {[
              ['00:00', '旧访谈考古', '顶流时间线存疑'],
              ['04:20', '深夜路透', '直播一哥现身园区'],
              ['09:12', '单据流出', '账目对不上说法'],
              ['13:45', '热议登顶', '口径对峙进入追踪'],
            ].map(([t, ti, de]) => (
              <div key={t as string} className="border-l-2 border-primary-200 pl-2.5">
                <p className="text-[11px] font-mono font-bold text-primary-500">{t as string}</p>
                <p className="mt-0.5 text-[12px] font-semibold text-foreground-900">{ti as string}</p>
                <p className="text-[11px] text-foreground-500">{de as string}</p>
              </div>
            ))}
          </div>
        )}

        {/* 手动切换头条 */}
        <div className="mt-1 flex items-center gap-3 rounded-2xl border border-primary-200 bg-primary-50/60 px-4 py-3">
          <span className="flex shrink-0 items-center gap-1 rounded bg-primary-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
            <i className="ri-close-circle-fill text-[11px]"></i> 头号曝料
          </span>
          <p className="min-w-0 flex-1 truncate text-[13px] font-medium text-primary-900">
            热度 {ticker}
          </p>
          <div className="flex shrink-0 gap-1">
            <button onClick={() => setTick((tick - 1 + marqueeItems.length) % marqueeItems.length)} className="flex h-7 w-7 items-center justify-center rounded-md border border-primary-200 bg-background-50 text-primary-600 hover:bg-primary-500 hover:text-background-50" aria-label="上一条">
              <i className="ri-arrow-left-line text-sm"></i>
            </button>
            <button onClick={() => setTick((tick + 1) % marqueeItems.length)} className="flex h-7 w-7 items-center justify-center rounded-md border border-primary-200 bg-background-50 text-primary-600 hover:bg-primary-500 hover:text-background-50" aria-label="下一条">
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}